<template>
    <div class="container-fluid">
        <v-title :breadcrumb="{label: 'API Keys', route: {name: 'api-keys'}}">
            API Keys
            <div slot="actions">
                <router-link
                    data-cy="Add API Key"
                    v-if="$auth.$pages['add-api-key'].isAllowed"
                    :to="{name: 'add-api-key'}"
                    class="btn btn-link">Add API Key<v-icon class="margin-left-xs" icon="arrow-right"/></router-link>
            </div>
        </v-title>
        <div class="grid flex-flow-column">
            <div class="grid-item">
                <grid
                    :columns="gridColumns"
                    :provider="provider"
                    :options="gridOptions"
                    :tabs="gridTabs"
                    @completed="stopLoadingPage"
                >
                    <v-no-content slot="no-content">
                        <span slot="title">It seems that you have no API key</span>
                        <span slot="description">Click on the button below to add your first API key.</span>
                        <div slot="actions">
                            <router-link
                                v-if="$auth.$pages['add-api-key'].isAllowed"
                                :to="{name: 'add-api-key'}"
                                class="btn btn-link">Add API Key<v-icon class="margin-left-xs" icon="arrow-right"/></router-link>                        </div>
                    </v-no-content>
                </grid>
            </div>
        </div>
    </div>
</template>

<script>
    import vTitle from '@/components/v-title';
    import {vIcon} from '@/components/form';
    import vNoContent from '@/components/v-no-content';
    import Clipboard from '@/common/clipboard';
    import Grid from '@/components/grid/grid';
    import LoadStateMixin from '@/mixins/load-state-mixin';
    import {createDialog, vConfirm} from '@/components/modal/dialogs';
    import TabsConfiguration from '@/components/grid/tabs/tabs-configuration';
    import apiKeyColumns from './api-key-columns';

    export default {
        name: 'api-keys',
        components: {
            vTitle, vIcon, Grid, vNoContent,
        },
        mixins: [LoadStateMixin],
        data() {
            return {
                gridColumns: apiKeyColumns(this.showDeleteAPIKeyDialog, this.copyAPIKey),
                gridOptions: {
                    defaultSort: {createdTime: 'desc'},
                },
                gridTabs: new TabsConfiguration({
                    id: 'api-keys-list',
                    store: this.$store,
                    systemTabs: [
                        {
                            label: 'All',
                            sortBy: {createdTime: 'desc'},
                        },
                    ],
                    version: 2,
                }),
            };
        },
        methods: {
            async showDeleteAPIKeyDialog(data, grid) {
                const confirmDialog = createDialog(vConfirm, this);
                const dialogParams = {
                    title: 'Delete API Key',
                    content: 'Are you sure you want to delete this item?',
                    confirmLabel: 'Delete',
                    dangerConfirm: true,
                };
                if (await confirmDialog(dialogParams)) {
                    this.deleteAPIKey(data, grid);
                }
            },
            async deleteAPIKey(data, grid) {
                try {
                    const params = {
                        id: data.fields.id,
                    };
                    grid.startLoading();
                    await this.$api(({apiKeys}) => apiKeys.delete(params));
                    grid.fetchData();
                    this.$toast.positive('API key successfully deleted');
                } catch (error) {
                    this.$toast.fromError(error);
                    grid.stopLoading();
                }
            },
            async copyAPIKey(data) {
                try {
                    await Clipboard.copy(data.fields.secretKey);
                    this.$toast.positive('API key copied successfully');
                } catch (error) {
                    this.$toast.negative(`Something went wrong`);
                }
            },
            provider(params) {
                return this.$api(({apiKeys}) => apiKeys.getAll(params));
            },
        },
    };
</script>
